exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".mp-toast-area {\n  bottom: 0;\n  display: flex;\n  flex-direction: column;\n  height: 100%;\n  justify-content: flex-end;\n  left: 20px;\n  pointer-events: none;\n  position: fixed;\n  z-index: 11000;\n}\n.mp-toast-area a {\n  color: #fff;\n}\n", ""]);

// exports
